// Shared pricing utility for Lagos (local), Interstate (Nigeria), and International.

// 2025 Express Rates (PND Export Rate)
const EXPRESS_RATES_2025 = {
  0.5: {
    1: 63300.04,
    2: 69945.26,
    3: 76906.88,
    4: 88931.58,
    5: 91463.1,
    6: 98424.7,
    7: 107917.88,
    8: 112548.0,
  },
  1.0: {
    1: 64218.8,
    2: 70864.02,
    3: 77825.64,
    4: 89850.33,
    5: 92381.85,
    6: 99343.46,
    7: 108836.64,
    8: 113466.76,
  },
  1.5: {
    1: 65452.51,
    2: 72069.97,
    3: 79031.59,
    4: 91056.27,
    5: 93587.79,
    6: 100549.41,
    7: 110042.59,
    8: 114672.71,
  },
  2.0: {
    1: 66630.69,
    2: 73275.92,
    3: 80237.53,
    4: 92262.22,
    5: 94793.73,
    6: 101755.36,
    7: 111248.53,
    8: 115878.65,
  },
  2.5: {
    1: 93124.15,
    2: 100880.02,
    3: 116355.02,
    4: 129250.0,
    5: 131830.0,
    6: 140857.1,
    7: 151173.58,
    8: 165359.37,
  },
  3.0: {
    1: 98442.14,
    2: 106179.72,
    3: 129578.62,
    4: 135369.31,
    5: 138767.16,
    6: 147794.25,
    7: 158929.9,
    8: 173934.02,
  },
  3.5: {
    1: 103749.35,
    2: 111479.1,
    3: 142802.23,
    4: 141487.7,
    5: 145704.28,
    6: 154731.38,
    7: 166685.7,
    8: 182508.67,
  },
  4.0: {
    1: 109041.51,
    2: 116779.08,
    3: 156025.82,
    4: 147606.1,
    5: 152641.44,
    6: 161668.53,
    7: 174441.6,
    8: 191083.3,
  },
  4.5: {
    1: 114341.2,
    2: 122078.77,
    3: 169249.42,
    4: 153724.51,
    5: 159578.58,
    6: 168605.67,
    7: 182197.5,
    8: 199657.96,
  },
  5.0: {
    1: 119640.9,
    2: 127378.46,
    3: 182473.02,
    4: 159842.89,
    5: 166515.72,
    6: 175542.81,
    7: 189953.41,
    8: 208232.61,
  },
  6.0: {
    1: 157106.25,
    2: 166738.56,
    3: 235289.74,
    4: 208859.55,
    5: 218473.99,
    6: 230176.99,
    7: 239224.5,
    8: 278078.53,
  },
  7.0: {
    1: 179614.26,
    2: 190045.2,
    3: 264247.9,
    4: 237232.66,
    5: 248834.32,
    6: 262834.16,
    7: 265377.98,
    8: 320416.52,
  },
  8.0: {
    1: 202122.28,
    2: 213351.82,
    3: 293206.09,
    4: 265587.68,
    5: 279194.62,
    6: 294291.75,
    7: 317930.1,
    8: 362754.54,
  },
  9.0: {
    1: 224630.3,
    2: 236658.46,
    3: 322164.26,
    4: 293951.72,
    5: 309554.96,
    6: 326249.13,
    7: 352282.86,
    8: 405092.5,
  },
  10.0: {
    1: 247138.3,
    2: 259965.07,
    3: 351122.43,
    4: 322315.78,
    5: 339915.26,
    6: 358206.51,
    7: 386635.66,
    8: 447430.51,
  },
  11.0: {
    1: 268075.88,
    2: 281648.01,
    3: 375220.12,
    4: 348576.91,
    5: 367986.33,
    6: 387768.16,
    7: 418433.19,
    8: 486574.47,
  },
  12.0: {
    1: 289013.46,
    2: 303330.93,
    3: 399317.82,
    4: 374838.04,
    5: 396057.42,
    6: 417329.83,
    7: 450230.69,
    8: 525718.45,
  },
  13.0: {
    1: 309951.04,
    2: 325013.86,
    3: 423415.52,
    4: 401099.18,
    5: 424128.49,
    6: 446891.48,
    7: 482028.21,
    8: 564862.4,
  },
  14.0: {
    1: 330888.62,
    2: 346696.8,
    3: 447513.21,
    4: 427360.3,
    5: 452199.56,
    6: 476453.14,
    7: 513825.72,
    8: 604006.38,
  },
  15.0: {
    1: 351826.2,
    2: 368379.72,
    3: 471610.9,
    4: 453621.44,
    5: 480270.64,
    6: 506014.82,
    7: 545623.25,
    8: 643150.34,
  },
  16.0: {
    1: 372763.77,
    2: 390062.65,
    3: 495708.6,
    4: 479882.56,
    5: 508341.72,
    6: 535576.47,
    7: 577420.77,
    8: 682294.3,
  },
  17.0: {
    1: 393701.35,
    2: 411745.58,
    3: 519806.31,
    4: 506143.7,
    5: 536412.8,
    6: 565138.14,
    7: 609218.29,
    8: 721438.27,
  },
  18.0: {
    1: 414638.92,
    2: 433428.51,
    3: 543904.0,
    4: 532404.84,
    5: 564483.87,
    6: 594699.79,
    7: 641015.74,
    8: 760582.24,
  },
  19.0: {
    1: 435576.5,
    2: 455111.44,
    3: 568001.7,
    4: 558665.97,
    5: 592554.96,
    6: 624261.45,
    7: 672813.25,
    8: 799726.2,
  },
  20.0: {
    1: 456514.08,
    2: 476794.38,
    3: 592099.39,
    4: 584927.1,
    5: 620626.03,
    6: 653823.1,
    7: 704610.75,
    8: 838870.17,
  },
  21.0: {
    1: 522181.92,
    2: 540962.73,
    3: 693610.94,
    4: 658945.65,
    5: 705297.36,
    6: 740512.41,
    7: 798838.21,
    8: 964070.15,
  },
  22.0: {
    1: 546952.37,
    2: 566627.62,
    3: 620735.26,
    4: 689600.7,
    5: 738787.71,
    6: 775679.67,
    7: 843108.6,
    8: 1014636.97,
  },
  23.0: {
    1: 571722.04,
    2: 592292.52,
    3: 648859.58,
    4: 720854.77,
    5: 772278.06,
    6: 810846.94,
    7: 872558.98,
    8: 1028257.78,
  },
  24.0: {
    1: 596493.61,
    2: 617957.42,
    3: 676983.92,
    4: 752109.32,
    5: 805768.41,
    6: 846014.19,
    7: 910409.38,
    8: 1125051.66,
  },
  25.0: {
    1: 621264.18,
    2: 643622.31,
    3: 705108.25,
    4: 783363.88,
    5: 839258.76,
    6: 881181.45,
    7: 948259.77,
    8: 1171845.42,
  },
};

const PROCESSING_FEE = 25;

const DEFAULTS = {
  localBaseFee: 1500,
  ecommerceBaseFee: 500,
  doorstepFee: 5000,
  haulageRatePerKg: 1500,
  cargoMinWeight: 10,
  cargoRates: { UK: 9500, CANADA: 17000, USA: 16500, OTHER: 8000 },
  lagosFallbackBaseRate: 4499,
  interStateZones: {
    1: [
      "Abeokuta",
      "Ado Ekiti",
      "Osogbo",
      "Ibadan",
      "iwo road",
      "challenge",
      "ring road",
      "Ilorin",
      "Akure",
      "Lagos",
    ],
    2: ["Aba", "Owerri", "Enugu", "Onitsha", "Awka"],
    3: ["Asaba", "Warri", "Benin"],
    4: ["Abuja", "Uyo", "Port Harcourt", "Bayelsa"],
    5: ["Kano", "Kaduna", "Makurdi", "Minna", "Bauchi"],
  },

  // ==========================================
  // INTERSTATE RATES (100% MATHEMATICALLY VERIFIED)
  // Formula: Base + rate6_10 = 5-10kg Price
  // ==========================================
  interStateZoneRates: {
    1: {
      baseRate: 5099,
      weightBrackets: { rate0_5: 0, rate6_10: 1476, rate10Plus: 700 },
    }, // MATH: 5099 + 1476 = 6575 (5-10kg)
    2: {
      baseRate: 6599,
      weightBrackets: { rate0_5: 0, rate6_10: 1376, rate10Plus: 770 },
    }, // MATH: 6599 + 1376 = 7975 (5-10kg)
    3: {
      baseRate: 5699,
      weightBrackets: { rate0_5: 0, rate6_10: 1876, rate10Plus: 870 },
    }, // MATH: 5699 + 1876 = 7575 (5-10kg)
    4: {
      baseRate: 6699,
      weightBrackets: { rate0_5: 0, rate6_10: 876, rate10Plus: 870 },
    }, // MATH: 6699 + 876 = 7575 (5-10kg)
    5: {
      baseRate: 9699,
      weightBrackets: { rate0_5: 0, rate6_10: 876, rate10Plus: 1170 },
    }, // MATH: 9699 + 876 = 10575 (5-10kg)
  },

  ecommerceInterStateZoneRates: {
    1: {
      baseRate: 4599,
      weightBrackets: { rate0_5: 0, rate6_10: 1776, rate10Plus: 500 },
    }, // MATH: 4599 + 1776 = 6375 (5-10kg)
    2: {
      baseRate: 5699,
      weightBrackets: { rate0_5: 0, rate6_10: 1876, rate10Plus: 650 },
    }, // MATH: 5699 + 1876 = 7575 (5-10kg)
    3: {
      baseRate: 5199,
      weightBrackets: { rate0_5: 0, rate6_10: 1376, rate10Plus: 730 },
    }, // MATH: 5199 + 1376 = 6575 (5-10kg)
    4: {
      baseRate: 5000,
      weightBrackets: { rate0_5: 0, rate6_10: 1575, rate10Plus: 730 },
    }, // MATH: 5000 + 1575 = 6575 (5-10kg)
    5: {
      baseRate: 7400,
      weightBrackets: { rate0_5: 0, rate6_10: 2175, rate10Plus: 1030 },
    }, // MATH: 7400 + 2175 = 9575 (5-10kg)
  },

  // ==========================================
  // LAGOS LOCAL RATES (100% MATHEMATICALLY VERIFIED)
  // ==========================================
  lagosZones: [
    {
      name: "Zone 1",
      baseRate: 3499,
      areas: [
        "Surulere",
        "Opebi",
        "Anthony",
        "Ejigbo",
        "Isolo",
        "Iyana Itire",
        "Ikeja",
        "Computer village Ikeja",
        "Arena market Oshodi",
        "Oshodi",
        "Obanikoro",
        "Mushin",
        "Palmgrove",
        "Onipanu",
        "Ago palace",
        "Ilupeju",
        "Jakande gate",
        "Gbagada",
        "Jibowu",
        "Fadeyi",
        "Maryland",
        "ojota",
        "Festac",
        "Amuwo odofin",
        "Oworonshoki",
        "Bariga",
        "Yaba",
        "Shomolu",
      ],
      weightBrackets: { rate0_5: 0, rate6_10: 3076, rate10Plus: 270 },
    }, // 3499 + 3076 = 6575
    {
      name: "Zone 2",
      baseRate: 3890,
      areas: [
        "Ikotun",
        "Idimu",
        "Ijegun",
        "Isheri oshun",
        "Costain",
        "Egbeda",
        "Gowon estate",
        "Akowonjo",
        "Cele egbe",
        "Agege",
        "Ketu",
        "Alapere",
        "Ebute metta",
        "Ogba",
        "Abule egba",
        "Igando",
        "Omole phase 1/2",
        "Magodo",
        "Ogudu",
        "Iyana ipaja",
        "Dopemu",
        "Ifako ijaiye",
        "Iju ishaga",
        "Meiran",
        "Alagbado",
        "Ayobo",
        "Alakuko",
      ],
      weightBrackets: { rate0_5: 0, rate6_10: 2185, rate10Plus: 325 },
    }, // 3890 + 2185 = 6075
    {
      name: "Zone 3",
      baseRate: 4499,
      areas: [
        "Mile 2",
        "Trade fair",
        "Alaba",
        "Maza Maza",
        "Abule ado",
        "Orile",
        "Ojo",
        "Iba",
        "Satellite town",
        "Navy town",
        "Ajegunle",
        "Apapa",
      ],
      weightBrackets: { rate0_5: 0, rate6_10: 1976, rate10Plus: 270 },
    }, // 4499 + 1976 = 6475
    {
      name: "Zone 4",
      baseRate: 5799,
      areas: [
        "Mowe",
        "Opic",
        "Ojodu Berger",
        "Ikorodu",
        "Ijainkin",
        "Iyana era",
        "Sangotedo",
        "Awoyaya",
        "Lakowe",
      ],
      weightBrackets: { rate0_5: 0, rate6_10: 1776, rate10Plus: 270 },
    }, // 5799 + 1776 = 7575
    {
      name: "Zone 5",
      baseRate: 4499,
      areas: [
        "Banana island",
        "Ikoyi",
        "Eko",
        "Oniru",
        "Admiralty Lekki",
        "Victoria Island",
        "Lagos Island",
        "CMS",
        "Idumota",
        "Marwa Lekki",
        "Lekki Phase 1",
        "Lekki phase 2",
        "Jakande lekki",
        "Osapa London",
        "Alpha beach Lekki",
        "Orchid Rd Lekki",
        "Ilasan Lekki",
        "Chevron Lekki",
        "VGC",
        "Ikota Lekki",
        "Agungi",
        "Ologolo",
        "Igbofon",
      ],
      weightBrackets: { rate0_5: 0, rate6_10: 2076, rate10Plus: 270 },
    }, // 4499 + 2076 = 6575
    {
      name: "Zone 6",
      baseRate: 5599,
      areas: [
        "Ajah",
        "Abraham adensanya",
        "Thomas estate",
        "LBS",
        "Lamgbasa",
        "Badore ajah",
        "Ogombo",
        "Addo",
      ],
      weightBrackets: { rate0_5: 0, rate6_10: 976, rate10Plus: 270 },
    }, // 5599 + 976 = 6575
  ],

  ecommerceLagosZones: [
    {
      name: "Zone 1",
      baseRate: 2499,
      areas: [
        "Surulere",
        "Opebi",
        "Anthony",
        "Ejigbo",
        "Isolo",
        "Iyana Itire",
        "Ikeja",
        "Computer village Ikeja",
        "Arena market Oshodi",
        "Oshodi",
        "Obanikoro",
        "Mushin",
        "Palmgrove",
        "Onipanu",
        "Ago palace",
        "Ilupeju",
        "Jakande gate",
        "Gbagada",
        "Jibowu",
        "Fadeyi",
        "Maryland",
        "ojota",
        "Festac",
        "Amuwo odofin",
        "Oworonshoki",
        "Bariga",
        "Yaba",
        "Shomolu",
      ],
      weightBrackets: { rate0_5: 0, rate6_10: 2076, rate10Plus: 100 },
    }, // 2499 + 2076 = 4575
    {
      name: "Zone 2",
      baseRate: 2499,
      areas: [
        "Ikotun",
        "Idimu",
        "Ijegun",
        "Isheri oshun",
        "Costain",
        "Egbeda",
        "Gowon estate",
        "Akowonjo",
        "Cele egbe",
        "Agege",
        "Ketu",
        "Alapere",
        "Ebute metta",
        "Ogba",
        "Abule egba",
        "Igando",
        "Omole phase 1/2",
        "Magodo",
        "Ogudu",
        "Iyana ipaja",
        "Dopemu",
        "Ifako ijaiye",
        "Iju ishaga",
        "Meiran",
        "Alagbado",
        "Ayobo",
        "Alakuko",
      ],
      weightBrackets: { rate0_5: 0, rate6_10: 2076, rate10Plus: 100 },
    }, // 2499 + 2076 = 4575
    {
      name: "Zone 3",
      baseRate: 2990,
      areas: [
        "Mile 2",
        "Trade fair",
        "Alaba",
        "Maza Maza",
        "Abule ado",
        "Orile",
        "Ojo",
        "Iba",
        "Satellite town",
        "Navy town",
        "Ajegunle",
        "Apapa",
      ],
      weightBrackets: { rate0_5: 0, rate6_10: 1685, rate10Plus: 100 },
    }, // 2990 + 1685 = 4675
    {
      name: "Zone 4",
      baseRate: 4499,
      areas: [
        "Mowe",
        "Opic",
        "Ojodu Berger",
        "Ikorodu",
        "Ijainkin",
        "Iyana era",
        "Sangotedo",
        "Awoyaya",
        "Lakowe",
      ],
      weightBrackets: { rate0_5: 0, rate6_10: 1176, rate10Plus: 170 },
    }, // 4499 + 1176 = 5675
    {
      name: "Zone 5",
      baseRate: 3499,
      areas: [
        "Banana island",
        "Ikoyi",
        "Eko",
        "Oniru",
        "Admiralty Lekki",
        "Victoria Island",
        "Lagos Island",
        "CMS",
        "Idumota",
        "Marwa Lekki",
        "Lekki Phase 1",
        "Lekki phase 2",
        "Jakande lekki",
        "Osapa London",
        "Alpha beach Lekki",
        "Orchid Rd Lekki",
        "Ilasan Lekki",
        "Chevron Lekki",
        "VGC",
        "Ikota Lekki",
        "Agungi",
        "Ologolo",
        "Igbofon",
      ],
      weightBrackets: { rate0_5: 0, rate6_10: 1076, rate10Plus: 170 },
    }, // 3499 + 1076 = 4575
    {
      name: "Zone 6",
      baseRate: 4199,
      areas: [
        "Ajah",
        "Abraham adensanya",
        "Thomas estate",
        "LBS",
        "Lamgbasa",
        "Badore ajah",
        "Ogombo",
        "Addo",
      ],
      weightBrackets: { rate0_5: 0, rate6_10: 376, rate10Plus: 130 },
    }, // 4199 + 376 = 4575
  ],
};

const DEFAULT_DOORSTEP_AVAILABLE_STATES = [
  "Abia",
  "Adamawa",
  "Akwa Ibom",
  "Anambra",
  "Bauchi",
  "Bayelsa",
  "Benue",
  "Borno",
  "Cross River",
  "Delta",
  "Ebonyi",
  "Edo",
  "Ekiti",
  "Enugu",
  "Abuja",
  "Gombe",
  "Imo",
  "Jigawa",
  "Kaduna",
  "Kano",
  "Katsina",
  "Kebbi",
  "Kogi",
  "Kwara",
  "Lagos",
  "Nasarawa",
  "Niger",
  "Ogun",
  "Ondo",
  "Osun",
  "Oyo",
  "Plateau",
  "Rivers",
  "Sokoto",
  "Taraba",
  "Yobe",
  "Zamfara",
];

const normalizeLocationKey = (value) =>
  String(value || "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, " ")
    .trim();

const INTERSTATE_LOCATION_ALIASES = {
  abeokuta: "ogun",
  "ado ekiti": "ekiti",
  osogbo: "osun",
  ibadan: "oyo",
  "iwo road": "oyo",
  challenge: "oyo",
  "ring road": "oyo",
  ilorin: "kwara",
  akure: "ondo",
  aba: "abia",
  owerri: "imo",
  onitsha: "anambra",
  awka: "anambra",
  asaba: "delta",
  warri: "delta",
  benin: "edo",
  "benin city": "edo",
  abuja: "fct abuja",
  fct: "fct abuja",
  "fct abuja": "fct abuja",
  uyo: "akwa ibom",
  "port harcourt": "rivers",
  portharcourt: "rivers",
  makurdi: "benue",
  minna: "niger",
  ogun: "ogun",
  ekiti: "ekiti",
  osun: "osun",
  oyo: "oyo",
  kwara: "kwara",
  ondo: "ondo",
  abia: "abia",
  imo: "imo",
  anambra: "anambra",
  delta: "delta",
  edo: "edo",
  "akwa ibom": "akwa ibom",
  rivers: "rivers",
  bayelsa: "bayelsa",
  kano: "kano",
  kaduna: "kaduna",
  benue: "benue",
  niger: "niger",
  bauchi: "bauchi",
  lagos: "lagos",
};

const calculateWeightFee = (weight, weightBrackets) => {
  if (!weightBrackets) return 0;
  if (weight <= 5) return 0;
  const bracket6_10 =
    Number(weightBrackets.rate6_10 ?? weightBrackets.rate5_10 ?? 0) || 0;
  if (weight <= 10) return bracket6_10;

  // For 11kg and above: Apply the flat 5-10kg fee PLUS the per-kg rate for anything over 10kg
  const perKgRate = Number(weightBrackets.rate10Plus || 0) || 0;
  return bracket6_10 + Math.max(0, weight - 10) * perKgRate;
};

const findLagosAreaRate = (areaName, lagosZones) => {
  if (!areaName || !lagosZones) return null;
  const normalizedSearch = normalizeLocationKey(areaName);

  // Handle new location categories
  if (normalizedSearch === "mainland") {
    const zone1 = lagosZones.find((z) =>
      z.name.toUpperCase().includes("ZONE 1"),
    );
    if (zone1)
      return {
        baseRate: Number(zone1.baseRate) || 0,
        additionalFee: 0,
        weightBrackets: zone1.weightBrackets,
      };
  }
  if (normalizedSearch === "island") {
    const zone5 = lagosZones.find((z) =>
      z.name.toUpperCase().includes("ZONE 5"),
    );
    if (zone5)
      return {
        baseRate: Number(zone5.baseRate) || 0,
        additionalFee: 0,
        weightBrackets: zone5.weightBrackets,
      };
  }
  if (normalizedSearch === "outskirt") {
    const zone4 = lagosZones.find((z) =>
      z.name.toUpperCase().includes("ZONE 4"),
    );
    if (zone4)
      return {
        baseRate: Number(zone4.baseRate) || 0,
        additionalFee: 0,
        weightBrackets: zone4.weightBrackets,
      };
  }

  const zones = Array.isArray(lagosZones)
    ? lagosZones
    : Object.values(lagosZones);
  for (const zone of zones) {
    if (zone && Array.isArray(zone.areas)) {
      const found = zone.areas.some(
        (a) => normalizeLocationKey(a) === normalizedSearch,
      );
      if (found) {
        let additionalFee = 0;
        if (zone.specialAreas) {
          const specialKey = Object.keys(zone.specialAreas).find(
            (k) => normalizeLocationKey(k) === normalizedSearch,
          );
          if (specialKey)
            additionalFee = Number(zone.specialAreas[specialKey]) || 0;
        }
        return {
          baseRate: Number(zone.baseRate) || 0,
          additionalFee,
          weightBrackets: zone.weightBrackets,
        };
      }
    }
  }
  return null;
};

function getInterstateZoneByState(state, interStateZones) {
  if (!state || !interStateZones) return null;
  const normalizedState = normalizeLocationKey(state);
  const normalizedStateAlias =
    INTERSTATE_LOCATION_ALIASES[normalizedState] || normalizedState;
  const zones = Array.isArray(interStateZones)
    ? interStateZones
    : Object.keys(interStateZones).map((key) => ({
        id: key,
        states: interStateZones[key],
      }));
  for (const zone of zones) {
    const states = Array.isArray(zone.states) ? zone.states : [];
    if (states.length > 0) {
      const hasMatch = states.some((entry) => {
        const normalizedEntry = normalizeLocationKey(entry);
        const normalizedEntryAlias =
          INTERSTATE_LOCATION_ALIASES[normalizedEntry] || normalizedEntry;
        return (
          normalizedEntry === normalizedState ||
          normalizedEntryAlias === normalizedStateAlias ||
          normalizedEntryAlias === normalizedState ||
          normalizedEntry === normalizedStateAlias
        );
      });
      if (hasMatch) return zone.id || zone.name;
    }
  }
  return null;
}

function getInternationalZone(country, zoneMapping) {
  if (!country || !zoneMapping) return null;
  const target = country.toUpperCase();
  for (const zoneKey of Object.keys(zoneMapping)) {
    const list = zoneMapping[zoneKey] || [];
    const match = list.find((c) => String(c).toUpperCase() === target);
    if (match) {
      const zoneNum = parseInt(zoneKey, 10);
      return Number.isNaN(zoneNum) ? null : zoneNum;
    }
  }
  return null;
}

function getExpressRate(weight, zone) {
  if (!weight || !zone) return null;
  const weights = Object.keys(EXPRESS_RATES_2025)
    .map(Number)
    .sort((a, b) => a - b);
  let targetWeight = weights.find((w) => w >= weight);
  if (!targetWeight) targetWeight = 25.0;
  const ratesForWeight = EXPRESS_RATES_2025[targetWeight];
  if (!ratesForWeight) return null;
  return ratesForWeight[zone] !== undefined ? ratesForWeight[zone] : null;
}

export function calculatePrice(payload, config) {
  if (!payload || !config) return null;

  const {
    serviceType,
    senderState: rawSenderState,
    receiverState: rawReceiverState,
    country: rawCountry,
    weight: rawWeight,
    userRole,
    subtype,
    deliveryType,
  } = payload;

  const weight = Number(rawWeight) || 0;
  const isEcommerce = userRole === "ecommerce";
  const senderState = rawSenderState || "";
  const receiverState = rawReceiverState || "";

  let effectiveServiceType = serviceType;
  if (serviceType === "local" && receiverState) {
    const safetyCheckZones =
      config?.interStateZones || DEFAULTS.interStateZones;
    if (getInterstateZoneByState(receiverState, safetyCheckZones)) {
      effectiveServiceType = "interstate";
    }
  }

  const country =
    rawCountry ||
    (effectiveServiceType === "international" ? receiverState : "");
  const interStateZones = config?.interStateZones || DEFAULTS.interStateZones;
  const zoneMapping = config?.zoneMapping || {};

  if (!effectiveServiceType) return null;
  let price = 0;

  // ==========================================
  // LOCAL SHIPMENT - ALWAYS USES HARDCODED DEFAULTS
  // ==========================================
  if (effectiveServiceType === "local") {
    const baseFee = 0;
    const localRateTable = isEcommerce
      ? DEFAULTS.ecommerceLagosZones
      : DEFAULTS.lagosZones;
    const areaRate = findLagosAreaRate(receiverState, localRateTable);

    if (areaRate) {
      const weightFee = calculateWeightFee(weight, areaRate.weightBrackets);
      price =
        areaRate.baseRate + weightFee + (areaRate.additionalFee || 0) + baseFee;
    } else {
      const fallbackBrackets = isEcommerce
        ? { rate0_5: 0, rate6_10: 1685, rate10Plus: 100 }
        : { rate0_5: 0, rate6_10: 1976, rate10Plus: 270 };
      const weightFee = calculateWeightFee(weight, fallbackBrackets);
      const fallbackBase = isEcommerce ? 2990 : 4499;
      price = fallbackBase + weightFee + baseFee;
    }
  }

  // ==========================================
  // INTERSTATE SHIPMENT - ALWAYS USES HARDCODED DEFAULTS
  // ==========================================
  else if (effectiveServiceType === "interstate") {
    if (senderState !== "Lagos") return null;
    const zone = getInterstateZoneByState(receiverState, interStateZones);
    if (zone === null) return null;

    const rateTable = isEcommerce
      ? DEFAULTS.ecommerceInterStateZoneRates
      : DEFAULTS.interStateZoneRates;
    let zoneRate = null;

    if (Array.isArray(rateTable)) {
      zoneRate = rateTable.find(
        (r) => String(r.id) === String(zone) || r.name === zone,
      );
    } else {
      zoneRate = rateTable?.[zone] || rateTable?.[String(zone)];
    }

    if (!zoneRate) return null;

    const baseRate = Number(zoneRate.baseRate) || 0;
    const weightFee = calculateWeightFee(weight, zoneRate.weightBrackets);

    // Base Rate + Weight Fee (which handles the 5-10kg jump and 10kg+ math perfectly)
    price = baseRate + weightFee;
  }

  // ==========================================
  // INTERNATIONAL SHIPMENT
  // ==========================================
  else if (effectiveServiceType === "international") {
    const baseFee = isEcommerce
      ? (config.ecommerceBaseFee ?? DEFAULTS.ecommerceBaseFee)
      : (config.standardBaseFee ?? DEFAULTS.localBaseFee);

    if (subtype === "cargo") {
      const minWeight = config.cargoMinWeight || DEFAULTS.cargoMinWeight;
      if (weight < minWeight) return null;
      const targetCountry = country.toUpperCase();
      const rates = config.cargoRates || DEFAULTS.cargoRates;
      let rate = rates.OTHER;

      if (
        [
          "UK",
          "UNITED KINGDOM",
          "GREAT BRITAIN",
          "ENGLAND",
          "IRELAND",
        ].includes(targetCountry)
      ) {
        rate = rates.UK;
      } else if (
        ["USA", "UNITED STATES", "U.S.A", "AMERICA"].includes(targetCountry)
      ) {
        rate = rates.USA;
      } else if (targetCountry === "CANADA") {
        rate = rates.CANADA;
      }
      price = weight * rate + baseFee;
    } else {
      const zone = getInternationalZone(country, zoneMapping);
      const expressRate = getExpressRate(weight, zone);
      if (expressRate !== null) {
        price = expressRate + baseFee;
      } else {
        price = 0;
      }
    }
  } else if (effectiveServiceType === "haulage") {
    const rate = Number(config?.haulageRatePerKg) || DEFAULTS.haulageRatePerKg;
    price = weight * rate;
  }

  if (typeof price === "number" && !isNaN(price) && price > 0) {
    if (deliveryType === "doorstep") {
      const doorstepFee =
        Number(config?.doorstepFee ?? DEFAULTS.doorstepFee) || 0;
      price += doorstepFee;
    }
    price += PROCESSING_FEE;
    return Math.round(price);
  }

  return null;
}

export default { calculatePrice };
export { PROCESSING_FEE };
